module.exports = __webpack_public_path__ + "static/media/dth11.743deda6.png";